import React, { useState, useEffect } from 'react';
import {
  Card,
  Stack,
  Button,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
} from '@mui/material';
import {
  ACTIVE_SUBSCRIBERS_COLUMNS_COUNTER,
  ACTIVE_SUBSCRIBERS_COLUMNS_REVENUE,
} from '../../config/module-configs/subscriber-reports.config';
import ListData from '../table-elements/list-data.component';
import Iconify from '../common/iconify.component';
import { getActiveSubscribers } from '../../services/admin-reports.service';
import useFilteredActions from '../../hooks/filtered-action.hook';
import useAbortableRequest from '../../hooks/abortable-request.hook';

const ActiveSubscribers = () => {
  const { getSignal, isAbortError } = useAbortableRequest();

  const actions = useFilteredActions('analytics', []);

  const [options, setOptions] = useState({
    page: 0,
    rowsPerPage: 100,
    totalRows: 0,
    rows: [],
    reloadCounter: 0,
    type: 'REVENUE',
    sortBy: '',
    sortOrder: '',
    error: false,
    loading: true,
  });

  const handlePageChange = (v) => {
    setOptions({
      ...options,
      page: v,
      reloadCounter: options.reloadCounter + 1,
      loading: true,
    });
  };
  const handleRowsPerPageChange = (v) => {
    setOptions({
      ...options,
      rowsPerPage: v,
      page: 0,
      reloadCounter: options.reloadCounter + 1,
      loading: true,
    });
  };
  const handleSortingChange = (sortBy, sortOrder) => {
    setOptions({
      ...options,
      sortBy,
      sortOrder,
      reloadCounter: options.reloadCounter + 1,
      loading: true,
    });
  };
  const handleRefreshData = () => {
    setOptions({
      ...options,
      reloadCounter: options.reloadCounter + 1,
      loading: true,
    });
  };

  const handleTypeChange = (event) => {
    const { value } = event.target;
    setOptions({
      ...options,
      type: value,
      reloadCounter: options.reloadCounter + 1,
      loading: true,
    });
  };

  useEffect(() => {
    const signal = getSignal();
    const params = [];
    params.push(`page=${options.page + 1}`);
    params.push(`perPage=${options.rowsPerPage}`);
    if (options.sortBy && options.sortOrder) {
      params.push(`sortBy=${options.sortBy}`);
      params.push(`sortOrder=${options.sortOrder}`);
    }
    if (options.type === 'REVENUE') {
      params.push('revenue=1');
    }

    const paramsQuery = params.length > 0 ? `?${params.join('&')}` : '';
    getActiveSubscribers(paramsQuery, signal)
      .then((res) => {
        if (!signal.aborted) {
          setOptions({
            ...options,
            loading: false,
            totalRows: res?.data?.totalRows || 0,
            rows: res?.data?.rows || [],
            error: false,
          });
        }
      })
      .catch((err) => {
        if (isAbortError(err)) return;
        setOptions({
          ...options,
          loading: false,
          page: 0,
          totalRows: 0,
          rows: [],
          error: true,
        });
      });
  }, [options.reloadCounter]);

  return (
    <>
      <Stack direction="row" justifyContent="right" sx={{ px: 0, py: 2 }}>
        <FormControl size="small">
          <InputLabel id="report-type-label">Report Type</InputLabel>
          <Select
            value={options.type || 'REVENUE'}
            onChange={handleTypeChange}
            labelId="report-type-label"
            label="Report Type"
            size="small"
            sx={{ width: 150, marginRight: 2 }}
          >
            <MenuItem value="REVENUE">Revenue</MenuItem>
            <MenuItem value="COUNT">Count</MenuItem>
          </Select>
        </FormControl>
        <Button
          color="inherit"
          variant="contained"
          startIcon={<Iconify icon="ic:twotone-refresh" />}
          onClick={handleRefreshData}
          disabled={options.loading}
        >
          Refresh
        </Button>
      </Stack>

      <Card>
        <ListData
          columns={
            options.type === 'REVENUE'
              ? ACTIVE_SUBSCRIBERS_COLUMNS_REVENUE
              : ACTIVE_SUBSCRIBERS_COLUMNS_COUNTER
          }
          rows={options.rows}
          page={options.page}
          rowsPerPage={options.rowsPerPage}
          totalRows={options.totalRows}
          loading={options.loading}
          actions={actions}
          error={options.error}
          sortBy={options.sortBy}
          sortOrder={options.sortOrder}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
          onSortChange={handleSortingChange}
          forReports
        />
      </Card>
    </>
  );
};

export default ActiveSubscribers;
